export default "__VITE_ASSET__BbX_doX4__"